import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { Vendor } from './vendor';
import { SharedService } from '../_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class VendorService {

  urlEndpoint = 'vendors';

  constructor(
    private http: HttpClient,
    private sharedService: SharedService
  ) {}

  findAll(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`).pipe(retry({ count: 2, delay: 1500 }));
  }

  findById(id: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
  }

  findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta: any, globalFilter: any, filters: any): Observable<ApiResponse> {
    const params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params }).pipe(retry({ count: 2, delay: 1500 }));
  }

  save(vendor: Vendor): Observable<ApiResponse> {
    if (vendor.vendorId) {
      return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, vendor);
    }
    return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, vendor);
  }

  delete(vendorId: number): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${vendorId}`);
  }
}
